// extracted by css-extract-rspack-plugin
export default {"grantsContainer":"GrantsPage_grantsContainer__PVnq0"};